import { Component, OnInit } from '@angular/core';
import { ConfigService } from '../../modules/common-shared-module/core/services/config/config.service';
import { ActivatedRoute, Params } from '@angular/router';
import { take } from 'rxjs/operators';
import { environment } from 'projects/eacatfront/src/environments/environment';

@Component({
	selector: 'app-redirect',
	templateUrl: './redirect.component.html',
	styleUrls: ['./redirect.component.scss']
})
export class RedirectComponent implements OnInit {

	private readonly moduleRouteMap: Record<string, string> = {
		'public-home': '/home/catproc/public-home',
		'public-catalog': '/home/catproc/public-catalog',
		'public-procedure': '/home/catproc/public-procedure',
		'public-registry-office': '/home/catproc/public-procedure/public-registry-office',
		'my-account-home': '/home/myaccount/my-account-home',
		'crossgen': '/cross/crossgen',
		'ensgen': '/configens/ensgen',
		'public-tgen': '/home/catproc/public-catalog/public-catalog-generic-proc-create',
		'public-tmas': '/home/catproc/public-batch'
	}

	private readonly allowedModules = Object.keys(this.moduleRouteMap)

	constructor(public activatedRoute: ActivatedRoute, public configService: ConfigService) { }

	ngOnInit(): void {
		this.activatedRoute.queryParams.pipe(take(1)).subscribe((params: Params) => {
			// Extract module and ine10, and save the rest in queryParams (no need to delete)
			const { module: moduleParam, ine10, ...queryParams } = params as Record<string, any>

			// Validate the module and normalize to string | undefined
			const module: string | undefined = this.allowedModules.includes(moduleParam ?? '')
				? moduleParam
				: undefined

			// If ine10 is present, change entity and redirect according to module
			if (ine10) {
				this.changeEnsByIne10(ine10, queryParams, module)
				return
			}

			const target = this.buildTargetUrl(queryParams, module)

			// Full page reload
			console.log('redirect module: ' + target)
			window.location.replace(target)
		})
	}

	changeEnsByIne10(ine10: string, queryParams: Record<string, any>, module?: string): void {
		this.configService.changeEnsByIne10(ine10).subscribe(r => {
			this.configService.config.putEntityAsRecent(r.connectedEntityDetail.entity.id)
			this.configService.config.reOrderEntities()

			const target = this.buildTargetUrl(queryParams, module)

			// Full page reload
			console.log('redirect module w/ine10: ' + target)
			window.location.replace(target)
		})
	}

	private buildTargetUrl(queryParams: Record<string, any>, module?: string): string {
    	const key = module ?? 'public-home'
		const basePath = environment.production ? '/webst' : ''
    	return basePath + (this.moduleRouteMap[key] ?? this.moduleRouteMap['public-home']) + this.addQueryParams(queryParams)
  	}

	private addQueryParams(queryParams: Record<string, any>): string {

		const qs = new URLSearchParams()

		Object.entries(queryParams ?? {}).forEach(([key, value]) => {
			if (value == null || value == undefined) return;
			qs.set(key, value)
		})

		const queryString = qs.toString()
		return queryString ? `?${queryString}` : ''
	}

}
